import { SELECIONAR_PERFIS, LIMPAR_PERFIS } from '../../actions/types'

const initialState = undefined

export default function reducerSelecionarPerfis (state = [], action = initialState) {
  switch (action.type) {
    case SELECIONAR_PERFIS: {
      return action.payload;
    }
    case LIMPAR_PERFIS: {
      return []
    }

    default: {
      return state
    }
  }
}
